// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"34":"category","42":"impressum","443":"about","631":"contact","850":"galery"}[chunkId] + "." + {"34":"4cdb9071","42":"88d8be9a","443":"02edae70","631":"efa0da93","850":"99e7a64e"}[chunkId] + ".js";
};